import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Modal, Button } from 'Components';
import './ConfirmDelete.css';

const ConfirmDelete = ({
  title,
  onCancelDelete,
  onProceedDelete,
}) => (
  <Modal show>
    <div className="templates-confirm-delete">
      <div className="templates-confirm-delete__container">
        <h3 className='templates-confirm-delete__message'>{title}?</h3>
        <div className="templates-confirm-delete__buttons">
          <Button onClick={onCancelDelete} className="button--primary">{i18n.t('common:Cancel')}</Button>
          <Button onClick={onProceedDelete} className="button--primary">{i18n.t('common:Proceed')}</Button>
        </div>
      </div>
    </div>
  </Modal>
);

ConfirmDelete.propTypes = {
  onProceedDelete: PropTypes.func,
  onCancelDelete: PropTypes.func,
  title: PropTypes.string,
};

export default ConfirmDelete;



// WEBPACK FOOTER //
// ./src/components/ConfirmDelete/ConfirmDelete.jsx